/**
 * @generated SignedSource<<ac117cb15882cd50dfec01e937ef4f1f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ArticleStatus = "CLOSED" | "DRAFT" | "OPEN" | "SOLVED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type CaseArticles_case$data = {
  readonly articleStatus: ArticleStatus;
  readonly description: string | null;
  readonly " $fragmentType": "CaseArticles_case";
};
export type CaseArticles_case$key = {
  readonly " $data"?: CaseArticles_case$data;
  readonly " $fragmentSpreads": FragmentRefs<"CaseArticles_case">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CaseArticles_case",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "articleStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    }
  ],
  "type": "CaseArticle",
  "abstractKey": null
};

(node as any).hash = "514407fc6d13151be60dc1318282226d";

export default node;
